import React from 'react';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';
import { PUBLIC_SITE_URL } from 'appConstants';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onContinue: any;
};

export const SubscriptionDoubleSubDiscountModal: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  onContinue,
}) => {
  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={'Double Subject Discount'}
      position="right"
      primaryBtnTxt="Continue"
      givenClass="SubscriptionDoubleSubDiscountModal"
      primaryBtnColor="BtnOrange"
      handleClose={() => togglePanelOpen(false)}
      handlePrimaryBtn={() => onContinue()}
      width={560}
    >
      <p>Want to access a double subject discount? Contact <a href={`${PUBLIC_SITE_URL}/contact-us`} target="_blank" rel="noreferrer">Get Set 4 Education</a> to align your subscriptions and receive a quote.</p>
    </PopupOrPanel>
  );
};
